import { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import { EChatModel } from "logic/src/objects/chat/types";

const WaitingKnowledge = ({ chatModel }: { chatModel: EChatModel }) => {
  // const [text, setText] = useState<string>("让我想一想～");
  const [thinkingTime, setThinkingTime] = useState<number>(1);
  const [collapsed, setCollapsed] = useState<boolean>(false);

  useEffect(() => {
    // setTimeout(() => {
    //   setText("请稍等片刻哟，我还在努力思考呢！");
    // }, 10000);
    const timer = setInterval(() => {
      setThinkingTime(prev => prev + 1);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const toggleCollapse = () => {
    setCollapsed(prev => !prev);
  };

  // 剪辑中
  if (chatModel === EChatModel.VideoEdit) {
    return (
      <div className={styles.container}>
        正在努力处理中...（已用时 {thinkingTime} 秒）
      </div>
    );
  }
  // 视频理解中
  if (chatModel === EChatModel.Video) {
    return (
      <>
        <div className={styles.processingTime}>
          视频理解中...（已用时 {thinkingTime} 秒）
        </div>
        <div className={`${styles.videoContainer}`}>
          <div className={styles.videoHeader}>
            <span>视频理解耗时较长，请您耐心等候</span>
            <div
              className={`${styles.arrowIcon} ${collapsed ? styles.collapsed : ""}`}
              onClick={toggleCollapse}
            />
          </div>

          {!collapsed && (
            <div className={styles.videoDetails}>
              <div>时长0~1分钟，理解耗时约为30s</div>
              <div>时长1~3分钟，理解耗时约为1分钟</div>
              <div>时长超过3分钟，理解耗时约为1~3分钟</div>
            </div>
          )}
        </div>
      </>
    );
  }

  return (
    <div className={styles.container}>
      正在思考中...（已用时 {thinkingTime} 秒）
    </div>
  );
};

export default WaitingKnowledge;
